import React from 'react'
import { Row, Col, Container } from 'react-grid-system';

import { bindActionCreators } from 'redux'
import { withRouter }         from 'react-router-dom'
import { connect }            from 'react-redux'

import './styles.scss'

import LocalFilesSystem    from '../../components/Fs/Local/S3'
import CloudFilesSystem    from '../../components/Fs/Cloud/files-system'

import SelectionFilesSize  from '../../components/S3Direct/Indicators/selection-files-size'
import SelectionFilesCount from '../../components/S3Direct/Indicators/selection-files-count'
import AccessControl       from '../../components/S3Direct/Indicators/access-control'

class Wasabi extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      access_control  : 'private',
      s3Acceleration  : false,

      selection : {
        size  : 0,
        cost  : 0,
        count : 0
      }
    }
  }

  componentWillReceiveProps(props) {
    this.setState({selection : props.selection})
  }

  on_acl_change(acl) {
    this.setState({ access_control : acl})
  }

  on_acceleration_change() {
    this.setState({s3Acceleration : !this.state.s3Acceleration})
  }

  render () {
    return (
      <Container className='s3_direct noselect' fluid>
        <Row className='header-row'>
          <Col md={3} >
            <SelectionFilesCount total_files_count={this.state.selection.count}/>
          </Col>

          <Col md={3}>
            <SelectionFilesSize total_files_size={this.state.selection.size}/>
          </Col>

          <Col md={6}>
            <AccessControl access_control={this.state.access_control} onChange={this.on_acl_change.bind(this)}/>
          </Col>
        </Row>

        <Row className='content-row'>
          <Col md={6}>
            <LocalFilesSystem s3Acceleration = {this.state.s3Acceleration}
                              access_control = {this.state.access_control}

                              provider       = {'wasabi'}/>
          </Col>

          <Col md={6}>
            <CloudFilesSystem
              title={'Wasabi Files System'}
              state={'wasabi'}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default withRouter(connect(({auth, s3Direct}, { match, history }) => {
  const user  = auth.user
  if(user){
    if(!user.acl.has_wasabi){
      history.push('/')
    }
  }

  return {
    user,
    selection : s3Direct.selection
  }
}, (dispatch) => bindActionCreators({}, dispatch))(Wasabi))
